import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    // marginTop: theme.spacing(13),
    width: '100%',
    height: '88px',
    direction: 'right',
    boxShadow: 'rgba(17, 17, 26, 0.1) 0px 0px 16px',
    borderRadius: '5px',
  },
  subtitle: {
    fontFamily: 'Public Sans,sans-serif',
    fontSize: '17px',
    fontWeight: 'bold',
    paddingTop: '10px',
    textAlign: 'center',
  },
  marqueeContainer: {
    // marginTop: theme.spacing(1),
    width: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    position: 'relative',
  },
  marqueeContent: {
    cursor: 'pointer',
    display: 'inline-block',
    padding: '0 100%',
    fontWeight: 'bold',
    fontFamily: 'Public Sans,sans-serif',
    fontSize: '21px',
    marginTop: '10px',
    animation: 'marquee 15s linear infinite',
    '&:hover': {
      animationPlayState: 'paused',
    },
  },
}));
